import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../../navbar/VisitorNav';
import { registerUser } from '../../../api/user/auth';
import styles from '../propertySeeker/Auth.module.css';

const RegisisterPropertyOwner = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    tell: '',
    gender: '',
    dob: '',
    password: '',
    confirm_pass: '',
    terms: false,
  });

  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Client-side validation
    if (formData.password !== formData.confirm_pass) {
      setError('Passwords do not match');
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (!formData.terms) {
      setError('Please agree to the Terms and Conditions');
      return;
    }

    setIsLoading(true);

    try {
      const response = await registerUser({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        tell: formData.tell || undefined,
        gender: formData.gender || undefined,
        dob: formData.dob || undefined,
        password: formData.password,
      });

      if (!response.success) {
        setError(response.message);
        return;
      }

      navigate(`/verify-email/${response.user._id}`);
    } catch (err) {
      setError(err.message || 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className={styles.authContainer}>
        <div className={styles.backgroundAnimation}></div>

        <div className={`${styles.authCard} ${styles.ownerCard}`}>
          <div className={styles.authHeader}>
            <div className={styles.authLogo}>
              SPOTFLI <i className="fa-solid fa-key" aria-hidden="true"></i>
            </div>
            <h2 className={styles.authTitle}>Become a Property Owner</h2>
            <p className={styles.authSubtitle}>
              List and manage your properties on Spotfli
            </p>
          </div>

          {error && (
            <div className={styles.errorMessage}>
              <i className={`fa fa-exclamation-circle ${styles.errorIcon}`}></i>
              {error}
            </div>
          )}

          <form className={styles.authForm} onSubmit={handleSubmit}>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="first_name">First Name</label>
                <input
                  className={styles.formInput}
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="last_name">Last Name</label>
                <input
                  className={styles.formInput}
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter your last name"
                  required
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="email">Email Address</label>
              <input
                className={styles.formInput}
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your.email@example.com"
                required
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="tell">Phone Number</label>
              <input
                className={styles.formInput}
                type="tel"
                name="tell"
                value={formData.tell}
                onChange={handleChange}
                placeholder="6XXXXXXXX"
              />
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Gender</label>
                <div className={styles.genderGroup}>
                  <label className={styles.genderOption}>
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      checked={formData.gender === 'male'}
                      onChange={handleChange}
                    />
                    Male
                  </label>
                  <label className={styles.genderOption}>
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      checked={formData.gender === 'female'}
                      onChange={handleChange}
                    />
                    Female
                  </label>
                </div>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="dob">Date of Birth</label>
                <input
                  className={styles.formInput}
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="password">Password</label>
              <div className={styles.passwordInputContainer}>
                <input
                  className={styles.formInput}
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Create a strong password"
                  required
                />
                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel} htmlFor="confirm_pass">Confirm Password</label>
              <div className={styles.passwordInputContainer}>
                <input
                  className={styles.formInput}
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirm_pass"
                  value={formData.confirm_pass}
                  onChange={handleChange}
                  placeholder="Confirm your password"
                  required
                />
                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            <div className={styles.termsGroup}>
              <input
                type="checkbox"
                name="terms"
                checked={formData.terms}
                onChange={handleChange}
                required
              />
              <span className={styles.termsText}>
                I agree to SPOTFLI&apos;s{' '}
                <Link to="/terms-conditions" className={styles.termsLink}>
                  Terms and Conditions
                </Link>
              </span>
            </div>

            <button className={styles.authButton} type="submit" disabled={isLoading}>
              {isLoading ? 'Creating Account...' : 'Register as Property Owner'}
            </button>

            <div className={styles.authLinks}>
              <span>Already have an account? </span>
              <Link to="/login" className={styles.authLink}>Sign In</Link>
              <span className={styles.linkSeparator}>•</span>
              <Link to="/register" className={styles.authLink}>Property Seeker</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RegisisterPropertyOwner;
